import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LinearScaleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"linear_scale"}/>
}
